import { useLocation } from "react-router";

export default function useParam() {
  return new URLSearchParams(useLocation().search);
}
